module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/job-posts/job-posts-create/job-posts-create.component.css
// module id = ./src/app/components/job-posts/job-posts-create/job-posts-create.component.css
// module chunks = main